// extracted by mini-css-extract-plugin
export var grid = "Columns-module--grid--HQ5Nc";